import { render } from "./Attributes.vue?vue&type=template&id=ffb0d70c&ts=true"
import script from "./Attributes.vue?vue&type=script&lang=ts"
export * from "./Attributes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__